// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"1dc4bda5","171":"42d76b7a","238":"6c7aaf95","640":"7bbd5eb5"}[chunkId] + ".chunk.js";
};